import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { selectData } from 'layouts/onboarding'

import { IntakeContext } from 'context/IntakeContext'
import { useDashboardCalculations } from '../hooks/useDashboardCalculations'
import { useFegliCalculations } from '../hooks/useFegliCalculations'
import { useContext, useState } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import SouthIcon from '@mui/icons-material/South'

const styledAccordion = {
  accordionWrapper: {
    '&.MuiPaper-root.MuiAccordion-root': {
      borderRadius: '0px',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: 'none',
      // borderBottom: '1px solid #ddd',
    },
    '&.MuiPaper-root.MuiAccordion-root:hover .MuiAccordionSummary-content.Mui-expanded, &.MuiPaper-root.MuiAccordion-root:hover .MuiAccordionDetails-root':
      {
        backgroundColor: '#F1F1F1',
      },
    '&.MuiPaper-root.MuiAccordion-root:hover .MuiPaper-root': {
      backgroundColor: '#F9F9F9',
    },
    '.MuiAccordionSummary-root, .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '48px',
      padding: '0',
    },
    '.MuiAccordionSummary-root:hover': {
      backgroundColor: '#F9F9F9',
    },
    '.MuiAccordionSummary-expandIconWrapper': {
      position: 'absolute',
      right: '0',
      color: '#ddd',
    },
    '&.MuiPaper-root.MuiAccordion-root:hover .MuiAccordionSummary-expandIconWrapper, .MuiAccordionSummary-root.Mui-expanded .MuiAccordionSummary-expandIconWrapper':
      {
        color: '#262627',
      },
    '.MuiAccordionSummary-expandIconWrapper>svg': {
      width: '1.5em',
      height: '1.5em',
    },
    '.MuiAccordionSummary-content, .MuiAccordionSummary-content.Mui-expanded': {
      margin: '0',
      padding: '0 20px',
    },
    '.MuiAccordionSummary-content.Mui-expanded': {
      backgroundColor: '#F9F9F9',
    },
    '.MuiAccordionSummary-content>div': {
      padding: '0',
    },
    '.MuiAccordionSummary-content>div>div': {
      padding: '12px 16px',
      borderLeft: '1px solid #ddd',
    },
    '.MuiAccordionSummary-content>div>div:first-of-type': {
      borderLeft: 'none',
      paddingLeft: '0px',
    },
    '.MuiAccordionDetails-root': {
      padding: '0px 20px 20px',
      background: '#f9F9F9',
    },
    '.MuiAccordionDetails-root .MuiAccordionDetails-root': {
      paddingBottom: '14px',
    },
  },
  accordionBorderCell: {
    borderBottom: '1px solid #ddd',
    padding: '0px',
  },
  accordionSummaryTable: {
    display: 'flex',
    width: '100%',
    '&>div': {
      textAlign: 'center',
    },
    '&>div:first-of-type': {
      textAlign: 'left',
    },
  },
  accordionSummaryNoTable: {
    display: 'flex',
    width: '100%',
    '&>div': {
      textAlign: 'center',
      padding: '12px 16px',
      borderLeft: '1px solid #ddd',
      borderTop: '2px solid #aaa',
    },
    '&>div:first-of-type': {
      borderLeft: 'none',
      textAlign: 'left',
      paddingLeft: '0px',
      borderTopColor: '#fff',
    },
  },
  accordionSummaryTableHeader: {
    width: '30%',
    minWidth: '275px',
    flex: '2 0 30%',
  },
  accordionSummaryTableCell: {
    width: '15%',
    minWidth: '135px',
    flex: '1 0 15%',
  },
  accordionDetailsTableContainer: {
    borderRadius: '0px',
    boxShadow: 0,
    border: '1px solid #ddd',
    borderRadius: '8px',
    backgroundColor: '#FFF',
  },
  accordionDetailsTableContainerRow: {
    display: 'flex',
    // borderBottom: '1px solid #ddd',
    '&:last-child td, &:last-child th': {
      border: 0,
    },
    '&:last-of-type td': {
      borderLeft: '1px solid #ddd',
    },
    '&.hideLine': { display: 'none' },
    td: {
      width: '15%',
      minWidth: '135px',
      borderLeft: '1px solid #ddd',
      borderBottom: '1px solid #ddd',
      flex: '1 0 15%',
    },
    'td:first-of-type': {
      width: '30%',
      minWidth: '275px',
      borderLeft: 'none',
      flex: '2 0 30%',
    },
  },
}

function createData(
  name,
  paycheck,
  working,
  retirement,
  difference,
  displayClass
) {
  return { name, paycheck, working, retirement, difference, displayClass }
}

// createData('Replace', '$', '$', '$'),

export const LeaveAndEarnings = ({
  deductions = [],
  liabilities = [],
  incomes = [],
  expenses = [],
  readinessScoreAdjustedMax,
  tableTimeHorizon = 'monthly',
  tableStates,
}) => {
  // console.log(tableStates)
  // console.log(tableTimeHorizon)
  // console.log(liabilities)
  const timeFactor = tableTimeHorizon === 'monthly' ? 1 : 12
  // console.log(timeFactor)
  const { intakeState } = useContext(IntakeContext)
  const { deductionTypes } = selectData
  const deductionSubTypeLabelMap = deductionTypes.reduce((summ, type) => {
    summ[type.value] = type.label

    return summ
  }, {})
  const {
    plannedRetirementMonth,
    plannedRetirementDay,
    plannedRetirementYear,
    bedb,
    basicLife,
    optionA,
    optionB,
    optionC,
    fegliTotal,
    privateInsurance,
    allLifeInsuranceTotal,
  } = useFegliCalculations()
  const {
    personalDetailsCurrentAge,
    eligibilityScenariosFirstFullyEligibleDate,
    netIncomeTodayCalculated,
    gapCalculated,
    netIncomeInRetirementCalculated,
    atRetirementGrossIncome,
    eligibilityScenariosModeledCYSinRetirement,
    socialSecurityEstimatedSocialSecurityatFRA,
    socialSecurityEstimatedSocialSecurityatAge62,
    socialSecuritySocialSecurityBenefit,
    FERSYearsOfService,
    atRetirementBasicLife,
    atRetirementIncomeTaxes,
    atRetirementGrossPension,
    atRetirementFERSSupplement,
    atRetirementSocialSecurity,
    atRetirementSSTaxes,
    atRetirementFEHB,
    creditableYearsOfServiceAtRetirement,
    survivorBenefitCost,
    atRetirementVERA,
    retirementAgeLessThanMRA,
  } = useDashboardCalculations(deductions)

  const dollarFormat = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })

  const [expanded, setExpanded] = useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const gaugeColors = {
    full:
      Math.round(readinessScoreAdjustedMax * 100) > 75
        ? '#4CAF50'
        : Math.round(readinessScoreAdjustedMax * 100) > 55
        ? '#FFCA59'
        : '#FD5C70',
    highlight:
      Math.round(readinessScoreAdjustedMax * 100) > 75
        ? '#c9e7ca'
        : Math.round(readinessScoreAdjustedMax * 100) > 55
        ? '#fcf0d7'
        : '#feced4',
    hover:
      Math.round(readinessScoreAdjustedMax * 100) > 75
        ? '#449d48'
        : Math.round(readinessScoreAdjustedMax * 100) > 55
        ? '#e5b550'
        : '#e35264',
  }

  // Constants
  const govSSTaxAmount = 160200
  const ssTaxPercent = 0.062
  const medicareTaxPercent = 0.0145
  const estimatedTaxRate = intakeState?.taxRate
    ? intakeState.taxRate / 100
    : 0.2
  // Create Pension Lookup Table to define
  const pensionAdjuster = new Date(intakeState?.dateOfHire)
  const pensionContribution =
    pensionAdjuster < new Date('2013-1-1')
      ? 0.008
      : pensionAdjuster < new Date('2014-1-1')
      ? 0.031
      : 0.044

  const birthYear = new Date(intakeState?.dateOfBirth).getFullYear()
  const minimumRetirementAge =
    birthYear < 1948
      ? 55
      : birthYear === 1948
      ? 55.1667
      : birthYear === 1949
      ? 55.333
      : birthYear === 1950
      ? 55.5
      : birthYear === 1951
      ? 55.667
      : birthYear === 1952
      ? 55.833
      : birthYear >= 1953 && birthYear <= 1964
      ? 56
      : birthYear === 1965
      ? 56.1667
      : birthYear === 1966
      ? 56.333
      : birthYear === 1967
      ? 56.5
      : birthYear === 1968
      ? 56.667
      : birthYear === 1969
      ? 56.833
      : 57

  const plannedRetirementDate = intakeState?.dateOfPlannedRetirement
    ? new Date(intakeState.dateOfPlannedRetirement)
    : null

  // Initial Sources and Deductions
  const baseSalary = (intakeState.baseSalary / 12) * timeFactor
  const baseSalaryPaycheck = (intakeState.baseSalary / 2087) * 80
  const workingNetTakeHome = intakeState?.netTakeHome
    ? (((intakeState?.netTakeHome / 80) * 2087) / 12) * timeFactor
    : 0
  const estiamtedSocialSecurity = intakeState.estimatedSocialSecurity
  const paycheckSocialSecurity = intakeState?.alreadyCollectingSocialSecurity
    ? ((estiamtedSocialSecurity * 12) / 2087) * 80
    : 0
  // change this Social Security benefit to inputted value if they are already collecting
  const estimatedSocialSecurityBenefit =
    socialSecuritySocialSecurityBenefit * timeFactor
  const estimatedFERSSupplement = atRetirementFERSSupplement * timeFactor
  const estimatedGrossPension = (atRetirementGrossPension / 12) * timeFactor
  const grossIncomeWorking =
    (intakeState.baseSalary / 12) * timeFactor +
    (intakeState?.alreadyCollectingSocialSecurity
      ? estimatedSocialSecurityBenefit
      : 0)
  const fersSupplementorSocialSecurity =
    atRetirementVERA && retirementAgeLessThanMRA
      ? 0
      : atRetirementFERSSupplement === 0
      ? estimatedSocialSecurityBenefit
      : estimatedFERSSupplement
  const fersSupplementorSocialSecurityTaxRate =
    atRetirementFERSSupplement === 0
      ? estimatedTaxRate * 0.85
      : estimatedTaxRate
  const grossIncomeRetirement =
    fersSupplementorSocialSecurity + estimatedGrossPension
  const grossIncomeDifference = 0 - baseSalary + grossIncomeRetirement

  // Normalized Gross Components
  const ssTaxPaycheckBaseSalaryAmount =
    (Math.min(
      intakeState.baseSalary * ssTaxPercent,
      govSSTaxAmount * ssTaxPercent
    ) /
      2087) *
    80
  const ssTaxBaseSalaryAmount =
    (Math.min(
      intakeState.baseSalary * ssTaxPercent,
      govSSTaxAmount * ssTaxPercent
    ) /
      12) *
    timeFactor
  const medicareTaxPaycheckBaseSalaryAmount =
    ((intakeState.baseSalary * medicareTaxPercent) / 2087) * 80
  const medicareTaxBaseSalaryAmount =
    ((intakeState.baseSalary * medicareTaxPercent) / 12) * timeFactor
  const pensionPaycheckContributionAmount =
    ((intakeState.baseSalary * pensionContribution) / 2087) * 80
  const pensionContributionAmount =
    ((intakeState.baseSalary * pensionContribution) / 12) * timeFactor
  const tspPaycheckContributionAmount =
    ((intakeState.baseSalary * (intakeState.tspContribution / 100)) / 2087) * 80
  const tspContributionAmount =
    ((intakeState.baseSalary * (intakeState.tspContribution / 100)) / 12) *
    timeFactor

  // Normalized Gross Income
  const normalizedAdjustmentsPaycheck =
    ssTaxPaycheckBaseSalaryAmount +
    medicareTaxPaycheckBaseSalaryAmount +
    pensionPaycheckContributionAmount +
    tspPaycheckContributionAmount

  const littleGPaycheckAmount =
    (intakeState.baseSalary / 2087) * 80 - normalizedAdjustmentsPaycheck
  const normalizedAdjustmentsWorking =
    ssTaxBaseSalaryAmount +
    medicareTaxBaseSalaryAmount +
    pensionContributionAmount +
    tspContributionAmount

  //Update
  const littleGAmount =
    (intakeState.baseSalary / 12) * timeFactor - normalizedAdjustmentsWorking
  const normalizedAdjustmentRetirement = survivorBenefitCost
  const normalizedGrossIncomeRetirement =
    grossIncomeRetirement - normalizedAdjustmentRetirement
  const normalizedAdjustmentDifference =
    ssTaxBaseSalaryAmount +
    medicareTaxBaseSalaryAmount +
    pensionContributionAmount +
    tspContributionAmount -
    normalizedAdjustmentRetirement
  const normalizedGrossDifference =
    grossIncomeDifference +
    ssTaxBaseSalaryAmount +
    medicareTaxBaseSalaryAmount +
    pensionContributionAmount +
    tspContributionAmount -
    normalizedAdjustmentRetirement

  // Other Deductions
  const healthInsurancePaycheckCost = intakeState.healthInsurancePremium
  const healthInsuranceCost =
    ((intakeState.healthInsurancePremium / 80) * 2087) / 12
  const healthInsuranceRetirementCost =
    intakeState?.healthInsurancePremiumRetirement
      ? intakeState.healthInsurancePremiumRetirement
      : ((intakeState?.healthInsurancePremium / 80) * 2087) / 12
  const basicLifePaycheckCost = ((basicLife?.premium * 12) / 2087) * 80
  const basicLifeCost = basicLife?.premium
  const basicLifeRetirementCost = basicLife?.retirementPremium
  const optionAPaycheckCost = ((optionA?.premium * 12) / 2087) * 80
  const optionACost = optionA?.premium
  const optionARetirementCost = optionA?.retirementPremium
  const optionBPaycheckCost = ((optionB?.premium * 12) / 2087) * 80
  const optionBCost = optionB?.premium
  const optionBRetirementCost = optionB?.retirementPremium
  const optionCPaycheckCost = ((optionC?.premium * 12) / 2087) * 80
  const optionCCost = optionC?.premium
  const optionCRetirementCost = optionC?.retirementPremium
  const estimatedTaxesPaycheckWhileWorking =
    littleGPaycheckAmount * estimatedTaxRate
  const estimatedTaxesWhileWorking = littleGAmount * estimatedTaxRate

  const estimatedTaxesInRetirement =
    (estimatedGrossPension - survivorBenefitCost) * estimatedTaxRate +
    fersSupplementorSocialSecurity * fersSupplementorSocialSecurityTaxRate

  const estimatedTaxesDifference =
    estimatedTaxesInRetirement - estimatedTaxesWhileWorking

  const initialSources = [
    createData(
      'Current Base Salary',
      dollarFormat.format(baseSalaryPaycheck),
      dollarFormat.format(baseSalary),
      '$0',
      dollarFormat.format(0 - baseSalary)
    ),
    createData(
      'Estimated Gross Pension',
      '$0',
      '$0',
      dollarFormat.format(estimatedGrossPension),
      dollarFormat.format(estimatedGrossPension)
    ),
    // createData(
    //   'Gross Income',
    //   dollarFormat.format(baseSalaryPaycheck),
    //   dollarFormat.format(grossIncomeWorking),
    //   dollarFormat.format(grossIncomeRetirement),
    //   dollarFormat.format(grossIncomeDifference)
    // ),
  ]
  const socialSecurity =
    atRetirementFERSSupplement === 0 &&
    initialSources.push(
      createData(
        intakeState?.alreadyCollectingSocialSecurity
          ? 'Social Security'
          : 'Estimated Gross Social Security',
        dollarFormat.format(paycheckSocialSecurity),
        dollarFormat.format(
          intakeState?.alreadyCollectingSocialSecurity
            ? estimatedSocialSecurityBenefit
            : 0
        ),
        dollarFormat.format(estimatedSocialSecurityBenefit),
        dollarFormat.format(estimatedSocialSecurityBenefit)
      )
    )
  const fersSupplement =
    atRetirementFERSSupplement > 0 &&
    initialSources.push(
      createData(
        atRetirementVERA && retirementAgeLessThanMRA
          ? 'FERS Supplement**'
          : 'FERS Supplement',
        '$0',
        '$0',
        dollarFormat.format(
          atRetirementVERA && retirementAgeLessThanMRA
            ? 0
            : estimatedFERSSupplement
        ),
        dollarFormat.format(
          atRetirementVERA && retirementAgeLessThanMRA
            ? 0
            : estimatedFERSSupplement
        )
      )
    )

  const totalTaxes = [
    createData(
      'Social Security Taxes',
      ssTaxPaycheckBaseSalaryAmount,
      ssTaxBaseSalaryAmount,
      0,
      0 - ssTaxBaseSalaryAmount
    ),
    createData(
      'Medicare Taxes',
      medicareTaxPaycheckBaseSalaryAmount,
      medicareTaxBaseSalaryAmount,
      0,
      0 - medicareTaxBaseSalaryAmount
    ),
    createData(
      'State and Federal Taxes',
      estimatedTaxesPaycheckWhileWorking,
      estimatedTaxesWhileWorking,
      estimatedTaxesInRetirement,
      estimatedTaxesDifference
    ),
  ]

  const taxesTotals = totalTaxes.reduce(
    (summ, deduction) => {
      summ.paycheck += +deduction.paycheck
      summ.working += +deduction.working
      summ.retirement += +deduction.retirement
      summ.difference += +deduction.difference
      return summ
    },
    { paycheck: 0, working: 0, retirement: 0, difference: 0 }
  )

  const normalizedGross = [
    createData(
      'Social Security Taxes',
      dollarFormat.format(ssTaxPaycheckBaseSalaryAmount),
      dollarFormat.format(ssTaxBaseSalaryAmount),
      '$0',
      dollarFormat.format(0 - ssTaxBaseSalaryAmount)
    ),
    createData(
      'Medicare Taxes',
      dollarFormat.format(medicareTaxPaycheckBaseSalaryAmount),
      dollarFormat.format(medicareTaxBaseSalaryAmount),
      '$0',
      dollarFormat.format(0 - medicareTaxBaseSalaryAmount)
    ),
    createData(
      'Pension Contributions',
      dollarFormat.format(pensionPaycheckContributionAmount),
      dollarFormat.format(pensionContributionAmount),
      '$0',
      dollarFormat.format(0 - pensionContributionAmount)
      // 'hideLine'
    ),
    createData(
      'TSP Contributions',
      dollarFormat.format(tspPaycheckContributionAmount),
      dollarFormat.format(tspContributionAmount),
      '$0',
      dollarFormat.format(0 - tspContributionAmount)
      // 'hideLine'
    ),
    // createData(
    //   'Normalized Gross Income',
    //   dollarFormat.format(littleGPaycheckAmount),
    //   dollarFormat.format(littleGAmount),
    //   dollarFormat.format(grossIncomeRetirement),
    //   dollarFormat.format(normalizedGrossDifference)
    // ),
  ]
  //Move this into deductions
  // const survivorBenefitRow =
  //   survivorBenefitCost > 0 &&
  //   normalizedGross.push(
  //     createData(
  //       'Survivor Benefit',
  //       dollarFormat.format(0),
  //       dollarFormat.format(0),
  //       dollarFormat.format(survivorBenefitCost),
  //       dollarFormat.format(survivorBenefitCost)
  //     )
  //   )

  const otherDeductions = [
    ...deductions.map(({ amount, subType, keepInRetirement }) => {
      const retirementAmount = keepInRetirement ? amount : 0
      return createData(
        deductionSubTypeLabelMap[subType],
        amount,
        (((amount / 80) * 2087) / 12) * timeFactor,
        (((retirementAmount / 80) * 2087) / 12) * timeFactor,
        ((((retirementAmount - amount) / 80) * 2087) / 12) * timeFactor
      )
    }),
  ]

  const liabilitiesMap = [
    ...liabilities
      .filter((liability) => liability.subType === 'tspLoan')
      .map(({ name, amount, loanEndDate, monthlyPayment }) => {
        return createData(
          name,
          monthlyPayment,
          ((monthlyPayment * 26) / 12) * timeFactor,
          ((monthlyPayment * 26) / 12) * timeFactor,
          0
        )
      }),
  ]

  const incomesAndExpenses = [...incomes, ...expenses]
  const workingIncomesExpenses = [
    ...incomesAndExpenses
      .filter((item) => {
        if (!item.ieStartDate) return true
        const today = new Date()
        const startDate = new Date(item.ieStartDate)
        return startDate <= today
      })
      .map(({ amount, name, frequency, type }) => {
        const typeAdjustmentAmount = type === 'expense' ? -amount : amount
        return createData(
          name,
          (((frequency === 'monthly'
            ? typeAdjustmentAmount
            : typeAdjustmentAmount / 12) *
            12) /
            2087) *
            80,
          (frequency === 'monthly'
            ? typeAdjustmentAmount
            : typeAdjustmentAmount / 12) * timeFactor,
          (frequency === 'monthly'
            ? typeAdjustmentAmount
            : typeAdjustmentAmount / 12) * timeFactor,
          0,
          '',
          '-'
        )
      }),
  ]
  const retirementIncomesExpenses = [
    ...incomesAndExpenses
      .filter((item) => {
        if (!item.ieStartDate) return true
        const retirementDate = new Date(plannedRetirementDate)
        const startDate = new Date(item.ieStartDate)
        const today = new Date()
        return startDate <= retirementDate || startDate <= today
      })
      .map(({ amount, name, frequency, type }) => {
        const typeAdjustmentAmount = type === 'expense' ? -amount : amount
        return createData(
          name,
          (((frequency === 'monthly'
            ? typeAdjustmentAmount
            : typeAdjustmentAmount / 12) *
            12) /
            2087) *
            80,
          (frequency === 'monthly'
            ? typeAdjustmentAmount
            : typeAdjustmentAmount / 12) * timeFactor,
          (frequency === 'monthly'
            ? typeAdjustmentAmount
            : typeAdjustmentAmount / 12) * timeFactor,
          0,
          '',
          '-'
        )
      }),
  ]

  const iEAdjustmentWorkingTotal = workingIncomesExpenses.reduce(
    (sum, { working }) => sum + Number(working),
    0
  )

  const iEAdjustmentRetiredTotal = retirementIncomesExpenses.reduce(
    (sum, { working }) => sum + Number(working),
    0
  )

  const cashAddbacks = [
    ...deductions
      .filter(
        (deduction) =>
          deduction.subType === 'alotchecking' ||
          deduction.subType === 'fsa' ||
          deduction.subType === 'hsa'
      )
      .map(({ amount, subType, keepInRetirement }) => {
        const retirementAmount = keepInRetirement ? amount : 0
        return createData(
          deductionSubTypeLabelMap[subType],
          amount,
          (((amount / 80) * 2087) / 12) * timeFactor,
          (((retirementAmount / 80) * 2087) / 12) * timeFactor,
          ((((retirementAmount - amount) / 80) * 2087) / 12) * timeFactor
        )
      }),
  ]
  const cashAddbacksTotals = cashAddbacks.reduce(
    (summ, deduction) => {
      summ.paycheck += +deduction.paycheck
      summ.working += +deduction.working
      summ.retirement += +deduction.retirement
      summ.difference += +deduction.difference
      return summ
    },
    { paycheck: 0, working: 0, retirement: 0, difference: 0 }
  )

  otherDeductions.push(
    createData(
      'Pension Contributions',
      pensionPaycheckContributionAmount,
      pensionContributionAmount,
      0,
      0 - pensionContributionAmount
      // 'hideLine'
    )
  )
  otherDeductions.push(
    createData(
      'TSP Contributions',
      tspPaycheckContributionAmount,
      tspContributionAmount,
      0,
      0 - tspContributionAmount
      // 'hideLine'
    )
  )
  const survivorBenefitRow =
    survivorBenefitCost > 0 &&
    otherDeductions.push(
      createData(
        'Survivor Benefit',
        0,
        0,
        survivorBenefitCost * timeFactor,
        survivorBenefitCost * timeFactor
      )
    )
  const healthInsuranceRow =
    healthInsurancePaycheckCost &&
    otherDeductions.push(
      createData(
        'Health Insurance',
        healthInsurancePaycheckCost,
        healthInsuranceCost * timeFactor,
        healthInsuranceRetirementCost * timeFactor,
        0
      )
    )
  const basicLifeRow =
    basicLife &&
    otherDeductions.push(
      createData(
        'Basic Life',
        basicLifePaycheckCost,
        basicLifeCost * timeFactor,
        basicLifeRetirementCost * timeFactor,
        (basicLifeRetirementCost - basicLifeCost) * timeFactor
      )
    )
  const optionARow =
    optionA &&
    otherDeductions.push(
      createData(
        'Option A',
        optionAPaycheckCost,
        optionACost * timeFactor,
        optionARetirementCost * timeFactor,
        (optionARetirementCost - optionACost) * timeFactor
      )
    )
  const optionBRow =
    optionB &&
    otherDeductions.push(
      createData(
        'Option B',
        optionBPaycheckCost,
        optionBCost * timeFactor,
        optionBRetirementCost * timeFactor,
        (optionBRetirementCost - optionBCost) * timeFactor
      )
    )
  const optionCRow =
    optionC &&
    otherDeductions.push(
      createData(
        'Option C',
        optionCPaycheckCost,
        optionCCost * timeFactor,
        optionCRetirementCost * timeFactor,
        (optionCRetirementCost - optionCCost) * timeFactor
      )
    )
  // const estimatedTaxesRow =
  //   estimatedTaxesPaycheckWhileWorking &&
  //   otherDeductions.push(
  //     createData(
  //       'Estimated Taxes',
  //       dollarFormat.format(estimatedTaxesPaycheckWhileWorking),
  //       dollarFormat.format(estimatedTaxesWhileWorking),
  //       dollarFormat.format(estimatedTaxesInRetirement),
  //       dollarFormat.format(estimatedTaxesDifference)
  //     )
  //   )

  // console.log(otherDeductions)

  // console.log(otherDeductions)

  function reorderDeductions(objects, order, key) {
    const orderMap = new Map(order.map((item, index) => [item, index]))
    return objects.sort(
      (a, b) =>
        (orderMap.get(a[key]) ?? Infinity) - (orderMap.get(b[key]) ?? Infinity)
    )
  }

  const deductionOrder = [
    'Survivor Benefit',
    'Pension Contributions',
    'TSP Contributions',
    'Health Insurance',
    'Basic Life',
    'Option A',
    'Option B',
    'Option C',
  ]

  const orderedOtherDeductions = reorderDeductions(
    otherDeductions,
    deductionOrder,
    'name'
  )

  const otherDeductionTotals = otherDeductions.reduce(
    (summ, deduction) => {
      summ.paycheck += +deduction.paycheck
      summ.working += +deduction.working
      summ.retirement += +deduction.retirement
      summ.difference += +deduction.difference
      return summ
    },
    { paycheck: 0, working: 0, retirement: 0, difference: 0 }
  )

  // net take-home pay
  const estimatedNetTakeHomePaycheckWhileWorking =
    littleGPaycheckAmount -
    otherDeductionTotals.paycheck -
    estimatedTaxesPaycheckWhileWorking +
    //add back in the contributions to TSP and Pension to compensate for the table adjustment
    (pensionPaycheckContributionAmount + tspPaycheckContributionAmount)
  const estimatedNetTakeHomeWhileWorking =
    littleGAmount -
    otherDeductionTotals.working -
    estimatedTaxesWhileWorking +
    //add back the contributions to TSP and Pension to compensate for the table adjustment
    (pensionContributionAmount + tspContributionAmount)
  const estimatedNetTakeHomeInRetirement =
    normalizedGrossIncomeRetirement -
    otherDeductionTotals.retirement -
    estimatedTaxesInRetirement +
    // add back the survivor benefit amount to compensate for the table adjustment
    survivorBenefitCost
  const estimatedNetTakeHomeDifference =
    estimatedNetTakeHomeInRetirement - estimatedNetTakeHomeWhileWorking

  // Adjusted Totals
  const adjustedNetTakeHomePaycheckWhileWorking =
    estimatedNetTakeHomePaycheckWhileWorking +
    cashAddbacksTotals.paycheck +
    (intakeState?.alreadyCollectingSocialSecurity ? paycheckSocialSecurity : 0)
  const adjustedNetTakeHomeWhileWorking =
    estimatedNetTakeHomeWhileWorking + cashAddbacksTotals.working
  const adjustedNetTakeHomeInRetirement =
    estimatedNetTakeHomeInRetirement +
    cashAddbacksTotals.retirement +
    iEAdjustmentRetiredTotal
  // swap out workingNetTakeHome for instead of adjustedNetTakeHomeWhileWorking
  const adjustedWorkingNetTakeHome =
    workingNetTakeHome +
    cashAddbacksTotals.working +
    (intakeState?.alreadyCollectingSocialSecurity
      ? intakeState?.estimatedSocialSecurity
      : 0) +
    iEAdjustmentWorkingTotal
  const adjustedNetTakeHomeDifference =
    adjustedNetTakeHomeInRetirement - adjustedWorkingNetTakeHome

  const bannerColors = {
    full: adjustedNetTakeHomeDifference >= 0 ? '#262627' : '#FD5C70',
  }

  // otherDeductions.push(
  //   createData(
  //     'Total Deductions',
  //     dollarFormat.format(otherDeductionTotals.paycheck),
  //     dollarFormat.format(otherDeductionTotals.working),
  //     dollarFormat.format(otherDeductionTotals.retirement),
  //     dollarFormat.format(otherDeductionTotals.difference)
  //   )
  // )
  // const tableDivider = [
  //   createData(
  //     'Other Deductions',
  //     dollarFormat.format(otherDeductionTotals.paycheck),
  //     dollarFormat.format(otherDeductionTotals.working),
  //     dollarFormat.format(otherDeductionTotals.retirement),
  //     dollarFormat.format(otherDeductionTotals.difference)
  //   ),
  // ]
  const tableDivider = [
    createData(
      'Adjusted Net Take Home Pay',
      dollarFormat.format(adjustedNetTakeHomePaycheckWhileWorking),
      dollarFormat.format(adjustedNetTakeHomeWhileWorking),
      dollarFormat.format(adjustedNetTakeHomeInRetirement),
      dollarFormat.format(adjustedNetTakeHomeDifference)
    ),
  ]

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '0px 0px 4px 4px',
          boxShadow: 0,
        }}
      >
        <Table sx={{}} size="small" aria-label="income reconciliation table">
          <TableHead
            sx={{ display: 'table-header-group', marginRight: '16px' }}
          >
            <TableRow>
              <TableCell colSpan={6} sx={styledAccordion.accordionBorderCell}>
                <Box
                  sx={{
                    display: 'flex',
                    padding: '0 0 0 20px',
                    // '&:has(> :nth-child(6))': {
                    //   padding: '0 20px',
                    // },
                    '&>div': {
                      padding: '12px 16px',
                      borderLeft: '1px solid #ddd',
                      borderTop: '1px solid #ddd',
                      borderRadius: '4px 4px 0 0',
                      fontWeight: '600',
                      textAlign: 'center',
                    },
                    '&>div:first-of-type': {
                      borderLeft: 'none',
                      borderTop: 'none',
                    },
                    '&>div:nth-last-of-type(2)': {
                      borderRadius: '4px 0 0 0',
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableHeader}
                  ></Typography>

                  {tableStates.paycheck && (
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        ...styledAccordion.accordionSummaryTableCell,
                        backgroundColor: '#EFF0F7',
                      }}
                    >
                      Paycheck
                    </Typography>
                  )}
                  {tableStates.working && (
                    <Typography
                      variant="body2"
                      component="div"
                      sx={styledAccordion.accordionSummaryTableCell}
                    >
                      Working
                    </Typography>
                  )}

                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableCell}
                  >
                    In Retirement
                  </Typography>

                  {tableStates.difference && (
                    <Typography
                      variant="body2"
                      component="div"
                      sx={styledAccordion.accordionSummaryTableCell}
                    >
                      Difference
                    </Typography>
                  )}
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      padding: '0 !important',
                      borderLeft: '0 !important',
                      borderRadius: '0 !important',
                      width: '20px',
                    }}
                  ></Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={6} sx={styledAccordion.accordionBorderCell}>
                <Accordion
                  expanded={expanded === 'panel1'}
                  onChange={handleChange('panel1')}
                  sx={styledAccordion.accordionWrapper}
                >
                  <AccordionSummary
                    aria-controls="panel1-content"
                    id="panel1-header"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Box sx={styledAccordion.accordionSummaryTable}>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableHeader}
                      >
                        Gross Income
                      </Typography>

                      {tableStates.paycheck && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={{
                            ...styledAccordion.accordionSummaryTableCell,
                            backgroundColor: '#EFF0F7',
                            borderleft: '1px solid #D2D6DA',
                          }}
                        >
                          {dollarFormat.format(baseSalaryPaycheck)}
                        </Typography>
                      )}
                      {tableStates.working && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={styledAccordion.accordionSummaryTableCell}
                        >
                          {dollarFormat.format(grossIncomeWorking)}
                        </Typography>
                      )}
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(grossIncomeRetirement)}
                      </Typography>

                      {tableStates.difference && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={styledAccordion.accordionSummaryTableCell}
                        >
                          {dollarFormat.format(grossIncomeDifference)}
                        </Typography>
                      )}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails onClick={handleChange('close')}>
                    <TableContainer
                      component={Paper}
                      sx={styledAccordion.accordionDetailsTableContainer}
                    >
                      <Table
                        sx={{ display: 'block' }}
                        size="small"
                        aria-label="income reconciliation table"
                      >
                        <TableBody sx={{ display: 'block' }}>
                          {initialSources.map((row, index) => (
                            <TableRow
                              key={row.name}
                              sx={
                                styledAccordion.accordionDetailsTableContainerRow
                              }
                              className={
                                tableStates.paycheck ||
                                tableStates.working ||
                                tableStates.difference
                                  ? ''
                                  : index !== 0
                                  ? ''
                                  : 'hideLine'
                              }
                            >
                              <TableCell>{row.name}</TableCell>
                              {tableStates.paycheck && (
                                <TableCell
                                  align="center"
                                  sx={{ backgroundColor: '#EFF0F7' }}
                                >
                                  {row.paycheck}
                                </TableCell>
                              )}
                              {tableStates.working && (
                                <TableCell align="center">
                                  {row.working}
                                </TableCell>
                              )}
                              <TableCell align="center">
                                {row.retirement}
                              </TableCell>
                              {tableStates.difference && (
                                <TableCell align="center">
                                  {row.difference}
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {atRetirementVERA && retirementAgeLessThanMRA && (
                      <Typography
                        variant="body1"
                        sx={{
                          lineHeight: '1.2',
                          fontStyle: 'italic',
                          padding: '10px 0 0 16px',
                          fontSize: '12px',
                        }}
                      >
                        **{dollarFormat.format(estimatedFERSSupplement)} will
                        begin at your Minimum Retirement Age (
                        {Math.round(minimumRetirementAge * 100) / 100})
                      </Typography>
                    )}
                  </AccordionDetails>
                </Accordion>
              </TableCell>
            </TableRow>
          </TableBody>
          {/* <TableBody>
            <TableRow>
              <TableCell colSpan={6} sx={styledAccordion.accordionBorderCell}>
                <Accordion
                  sx={styledAccordion.accordionWrapper}
                >
                  <AccordionSummary
                    aria-controls="panel2-content"
                    id="panel2-header"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Box
                      sx={styledAccordion.accordionSummaryTable}
                    >
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableHeader}
                      >
                        Normalizations
                      </Typography>

                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          ...styledAccordion.accordionSummaryTableCell,
                          backgroundColor: '#EFF0F7',
                          borderleft: '1px solid #D2D6DA',
                        }}
                      >
                        {dollarFormat.format(-normalizedAdjustmentsPaycheck)}
                      </Typography>

                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(-normalizedAdjustmentsWorking)}
                      </Typography>

                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(-normalizedAdjustmentRetirement)}
                      </Typography>

                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(-normalizedAdjustmentDifference)}
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails onClick={handleChange('close')}>
                    <TableContainer
                      component={Paper}
                      sx={styledAccordion.accordionDetailsTableContainer}
                    >
                      <Table
                        sx={{}}
                        size="small"
                        aria-label="income reconciliation table"
                      >
                        <TableBody>
                          {normalizedGross.map((row) => (
                            <TableRow
                              key={row.name}
                              sx={
                                styledAccordion.accordionDetailsTableContainerRow
                              }
                            >
                              <TableCell>{row.name}</TableCell>
                              <TableCell align="center" sx={{ backgroundColor: '#EFF0F7' }}>
                                {row.paycheck}
                              </TableCell>
                              <TableCell align="center">
                                {row.working}
                              </TableCell>
                              <TableCell align="center">
                                {row.retirement}
                              </TableCell>
                              <TableCell align="center">
                                {row.difference}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              </TableCell>
            </TableRow>
          </TableBody> */}
          {/* <TableBody>
            <TableRow>
              <TableCell colSpan={6} sx={styledAccordion.accordionBorderCell}>
                <Box
                  sx={styledAccordion.accordionSummaryTable}>
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableHeader}
                  >
                    Normalized Gross Income
                  </Typography>

                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      ...styledAccordion.accordionSummaryTableCell,
                      backgroundColor: '#EFF0F7',
                      borderleft: '1px solid #D2D6DA',
                    }}
                  >
                    {dollarFormat.format(littleGPaycheckAmount)}
                  </Typography>

                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableCell}
                  >
                    {dollarFormat.format(littleGAmount)}
                  </Typography>

                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableCell}
                  >
                    {dollarFormat.format(normalizedGrossIncomeRetirement)}
                  </Typography>

                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableCell}
                  >
                    {dollarFormat.format(normalizedGrossDifference)}
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody> */}
          <TableBody>
            <TableRow>
              <TableCell colSpan={6} sx={styledAccordion.accordionBorderCell}>
                <Accordion
                  expanded={expanded === 'panel3'}
                  onChange={handleChange('panel3')}
                  sx={styledAccordion.accordionWrapper}
                >
                  <AccordionSummary
                    aria-controls="panel3-content"
                    id="panel3-header"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Box sx={styledAccordion.accordionSummaryTable}>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableHeader}
                      >
                        Deductions
                      </Typography>

                      {tableStates.paycheck && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={{
                            ...styledAccordion.accordionSummaryTableCell,
                            backgroundColor: '#EFF0F7',
                            borderleft: '1px solid #D2D6DA',
                          }}
                        >
                          {dollarFormat.format(-otherDeductionTotals.paycheck)}
                        </Typography>
                      )}
                      {tableStates.working && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={styledAccordion.accordionSummaryTableCell}
                        >
                          {dollarFormat.format(-otherDeductionTotals.working)}
                        </Typography>
                      )}
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(-otherDeductionTotals.retirement)}
                      </Typography>

                      {tableStates.difference && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={styledAccordion.accordionSummaryTableCell}
                        >
                          {dollarFormat.format(otherDeductionTotals.difference)}
                        </Typography>
                      )}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails onClick={handleChange('close')}>
                    <TableContainer
                      component={Paper}
                      sx={styledAccordion.accordionDetailsTableContainer}
                    >
                      <Table
                        sx={{ display: 'block' }}
                        size="small"
                        aria-label="income reconciliation table"
                      >
                        <TableBody sx={{ display: 'block' }}>
                          {orderedOtherDeductions.map((row) => (
                            <TableRow
                              key={row.name}
                              sx={
                                styledAccordion.accordionDetailsTableContainerRow
                              }
                              className={
                                tableStates.paycheck ||
                                tableStates.working ||
                                tableStates.difference
                                  ? ''
                                  : row.retirement !== 0
                                  ? ''
                                  : 'hideLine'
                              }
                            >
                              <TableCell>{row.name}</TableCell>
                              {tableStates.paycheck && (
                                <TableCell
                                  align="center"
                                  sx={{ backgroundColor: '#EFF0F7' }}
                                >
                                  {dollarFormat.format(row.paycheck)}
                                </TableCell>
                              )}
                              {tableStates.working && (
                                <TableCell align="center">
                                  {dollarFormat.format(row.working)}
                                </TableCell>
                              )}
                              <TableCell align="center">
                                {dollarFormat.format(row.retirement)}
                              </TableCell>
                              {tableStates.difference && (
                                <TableCell align="center">
                                  {dollarFormat.format(row.difference)}
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              </TableCell>
            </TableRow>
          </TableBody>
          <TableBody>
            <TableRow>
              <TableCell colSpan={6} sx={styledAccordion.accordionBorderCell}>
                <Accordion
                  expanded={expanded === 'panel4'}
                  onChange={handleChange('panel4')}
                  sx={styledAccordion.accordionWrapper}
                >
                  <AccordionSummary
                    aria-controls="panel4-content"
                    id="panel4-header"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Box sx={styledAccordion.accordionSummaryTable}>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableHeader}
                      >
                        Taxes
                      </Typography>

                      {tableStates.paycheck && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={{
                            ...styledAccordion.accordionSummaryTableCell,
                            backgroundColor: '#EFF0F7',
                            borderleft: '1px solid #D2D6DA',
                          }}
                        >
                          {dollarFormat.format(-taxesTotals.paycheck)}
                        </Typography>
                      )}
                      {tableStates.working && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={styledAccordion.accordionSummaryTableCell}
                        >
                          {dollarFormat.format(-taxesTotals.working)}
                        </Typography>
                      )}
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(-taxesTotals.retirement)}
                      </Typography>

                      {tableStates.difference && (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={styledAccordion.accordionSummaryTableCell}
                        >
                          {dollarFormat.format(-taxesTotals.difference)}
                        </Typography>
                      )}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails onClick={handleChange('close')}>
                    <TableContainer
                      component={Paper}
                      sx={styledAccordion.accordionDetailsTableContainer}
                    >
                      <Table
                        sx={{ display: 'block' }}
                        size="small"
                        aria-label="income reconciliation table"
                      >
                        <TableBody sx={{ display: 'block' }}>
                          {totalTaxes.map((row) => (
                            <TableRow
                              key={row.name}
                              sx={
                                styledAccordion.accordionDetailsTableContainerRow
                              }
                              className={
                                tableStates.paycheck ||
                                tableStates.working ||
                                tableStates.difference
                                  ? ''
                                  : row.retirement !== 0
                                  ? ''
                                  : 'hideLine'
                              }
                            >
                              <TableCell>{row.name}</TableCell>
                              {tableStates.paycheck && (
                                <TableCell
                                  align="center"
                                  sx={{ backgroundColor: '#EFF0F7' }}
                                >
                                  {dollarFormat.format(row.paycheck)}
                                </TableCell>
                              )}
                              {tableStates.working && (
                                <TableCell align="center">
                                  {dollarFormat.format(row.working)}
                                </TableCell>
                              )}
                              <TableCell align="center">
                                {dollarFormat.format(row.retirement)}
                              </TableCell>
                              {tableStates.difference && (
                                <TableCell align="center">
                                  {dollarFormat.format(row.difference)}
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              </TableCell>
            </TableRow>
          </TableBody>
          {/* <TableBody>
            <TableRow>
              <TableCell colSpan={6} sx={styledAccordion.accordionBorderCell}>
                <Accordion
                  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")}
                  sx={styledAccordion.accordionWrapper}
                >
                  <AccordionSummary
                    aria-controls="panel5-content"
                    id="panel5-header"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Box sx={styledAccordion.accordionSummaryTable}>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableHeader}
                      >
                        Net Pay
                      </Typography>

                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          ...styledAccordion.accordionSummaryTableCell,
                          backgroundColor: '#EFF0F7',
                          borderleft: '1px solid #D2D6DA',
                        }}
                      >
                        {dollarFormat.format(littleGPaycheckAmount)}
                      </Typography>

                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(littleGAmount)}
                      </Typography>

                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(grossIncomeRetirement)}
                      </Typography>

                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableCell}
                      >
                        {dollarFormat.format(normalizedGrossDifference)}
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails onClick={handleChange('close')}>
                    <TableContainer
                      component={Paper}
                      sx={styledAccordion.accordionDetailsTableContainer}
                    >
                      <Table
                        sx={{}}
                        size="small"
                        aria-label="income reconciliation table"
                      >
                        <TableBody>
                          {normalizedGross.map((row) => (
                            <TableRow
                              key={row.name}
                              sx={
                                styledAccordion.accordionDetailsTableContainerRow
                              }
                            >
                              <TableCell>{row.name}</TableCell>
                              <TableCell align="center" sx={{ backgroundColor: '#EFF0F7' }}>
                                {row.paycheck}
                              </TableCell>
                              <TableCell align="center">
                                {row.working}
                              </TableCell>
                              <TableCell align="center">
                                {row.retirement}
                              </TableCell>
                              <TableCell align="center">
                                {row.difference}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              </TableCell>
            </TableRow>
          </TableBody> */}
          {(tableStates.paycheck ||
            tableStates.working ||
            tableStates.difference) &&
            cashAddbacks.length > 0 && (
              <>
                {/* <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      sx={{
                        ...styledAccordion.accordionBorderCell,
                        padding: '0 0 0 20px',
                      }}
                    >
                      <Box sx={styledAccordion.accordionSummaryNoTable}>
                        <Typography
                          variant="body2"
                          component="div"
                          sx={styledAccordion.accordionSummaryTableHeader}
                        >
                          Net Pay
                        </Typography>

                        {tableStates.paycheck && (
                          <Typography
                            variant="body2"
                            component="div"
                            sx={{
                              ...styledAccordion.accordionSummaryTableCell,
                              backgroundColor: '#EFF0F7',
                              borderleft: '1px solid #D2D6DA',
                            }}
                          >
                            {dollarFormat.format(
                              estimatedNetTakeHomePaycheckWhileWorking
                            )}
                          </Typography>
                        )}
                        {tableStates.working && (
                          <Typography
                            variant="body2"
                            component="div"
                            sx={styledAccordion.accordionSummaryTableCell}
                          >
                            {dollarFormat.format(
                              estimatedNetTakeHomeWhileWorking
                            )}
                          </Typography>
                        )}
                        <Typography
                          variant="body2"
                          component="div"
                          sx={styledAccordion.accordionSummaryTableCell}
                        >
                          {dollarFormat.format(
                            estimatedNetTakeHomeInRetirement
                          )}
                        </Typography>

                        {tableStates.difference && (
                          <Typography
                            variant="body2"
                            component="div"
                            sx={styledAccordion.accordionSummaryTableCell}
                          >
                            {dollarFormat.format(
                              estimatedNetTakeHomeDifference
                            )}
                          </Typography>
                        )}
                        <Typography
                          variant="body2"
                          component="div"
                          sx={{
                            padding: '0 !important',
                            borderLeft: '0 !important',
                            borderRadius: '0 !important',
                            width: '20px',
                          }}
                        ></Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody> */}
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      sx={styledAccordion.accordionBorderCell}
                    >
                      <Accordion
                        expanded={expanded === 'panel6'}
                        onChange={handleChange('panel6')}
                        sx={styledAccordion.accordionWrapper}
                      >
                        <AccordionSummary
                          aria-controls="panel6-content"
                          id="panel6-header"
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <Box sx={styledAccordion.accordionSummaryTable}>
                            <Typography
                              variant="body2"
                              component="div"
                              sx={styledAccordion.accordionSummaryTableHeader}
                            >
                              Cash Addbacks
                            </Typography>

                            {tableStates.paycheck && (
                              <Typography
                                variant="body2"
                                component="div"
                                sx={{
                                  ...styledAccordion.accordionSummaryTableCell,
                                  backgroundColor: '#EFF0F7',
                                  borderleft: '1px solid #D2D6DA',
                                }}
                              >
                                +
                                {dollarFormat.format(
                                  cashAddbacksTotals.paycheck
                                )}
                              </Typography>
                            )}
                            {tableStates.working && (
                              <Typography
                                variant="body2"
                                component="div"
                                sx={styledAccordion.accordionSummaryTableCell}
                              >
                                +
                                {dollarFormat.format(
                                  cashAddbacksTotals.working
                                )}
                              </Typography>
                            )}
                            <Typography
                              variant="body2"
                              component="div"
                              sx={styledAccordion.accordionSummaryTableCell}
                            >
                              {dollarFormat.format(
                                cashAddbacksTotals.retirement
                              )}
                            </Typography>

                            {tableStates.difference && (
                              <Typography
                                variant="body2"
                                component="div"
                                sx={styledAccordion.accordionSummaryTableCell}
                              >
                                {dollarFormat.format(
                                  cashAddbacksTotals.difference
                                )}
                              </Typography>
                            )}
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails onClick={handleChange('close')}>
                          <TableContainer
                            component={Paper}
                            sx={styledAccordion.accordionDetailsTableContainer}
                          >
                            <Table
                              sx={{ display: 'block' }}
                              size="small"
                              aria-label="income reconciliation table"
                            >
                              <TableBody sx={{ display: 'block' }}>
                                {cashAddbacks.map((row) => (
                                  <TableRow
                                    key={row.name}
                                    sx={
                                      styledAccordion.accordionDetailsTableContainerRow
                                    }
                                  >
                                    <TableCell>{row.name}</TableCell>
                                    {tableStates.paycheck && (
                                      <TableCell
                                        align="center"
                                        sx={{ backgroundColor: '#EFF0F7' }}
                                      >
                                        {dollarFormat.format(row.paycheck)}
                                      </TableCell>
                                    )}
                                    {tableStates.working && (
                                      <TableCell align="center">
                                        {dollarFormat.format(row.working)}
                                      </TableCell>
                                    )}
                                    <TableCell align="center">
                                      {dollarFormat.format(row.retirement)}
                                    </TableCell>
                                    {tableStates.difference && (
                                      <TableCell align="center">
                                        {dollarFormat.format(row.difference)}
                                      </TableCell>
                                    )}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            )}
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={6}
                sx={{
                  ...styledAccordion.accordionBorderCell,
                  padding: '0 0 0 20px',
                  borderBottom: '0px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    padding: '0',
                    '&>div': {
                      padding: '12px 16px',
                      borderLeft: '1px solid #ddd',
                      fontWeight: '600',
                      textAlign: 'center',
                      borderTop: '4px solid #ddd',
                    },
                    '&>div:first-of-type': {
                      borderTopColor: '#fff',
                      borderLeft: 'none',
                      textAlign: 'left',
                      paddingLeft: '0px',
                    },
                    '&>div.differenceCell+div': {
                      // backgroundColor: gaugeColors.highlight,
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableHeader}
                  >
                    Take Home Pay
                  </Typography>

                  {tableStates.paycheck && (
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        ...styledAccordion.accordionSummaryTableCell,
                        backgroundColor: '#EFF0F7',
                        borderleft: '1px solid #D2D6DA',
                      }}
                    >
                      {dollarFormat.format(
                        adjustedNetTakeHomePaycheckWhileWorking
                      )}
                    </Typography>
                  )}
                  {tableStates.working && (
                    <Typography
                      variant="body2"
                      component="div"
                      sx={styledAccordion.accordionSummaryTableCell}
                    >
                      {dollarFormat.format(adjustedWorkingNetTakeHome)}
                    </Typography>
                  )}
                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableCell}
                  >
                    {dollarFormat.format(adjustedNetTakeHomeInRetirement)}
                  </Typography>

                  {tableStates.difference && (
                    <Typography
                      variant="body2"
                      component="div"
                      className="differenceCell"
                      sx={{
                        ...styledAccordion.accordionSummaryTableCell,
                        // border: `1px solid ${gaugeColors.full} !important`,
                        // backgroundColor: gaugeColors.highlight,
                        color: bannerColors.full,
                      }}
                    >
                      {dollarFormat.format(adjustedNetTakeHomeDifference)}
                    </Typography>
                  )}
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      padding: '0 !important',
                      borderLeft: '0 !important',
                      borderRadius: '0 !important',
                      width: '20px',
                    }}
                  ></Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8f9fa',
          color: 'white',
          padding: '8px',
          '&>svg': {
            color: '#262726',
            fontSize: '32px !important',
            display: 'block',
          },
        }}
      >
        <SouthIcon />
      </Box>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '0px 0px 4px 4px',
          boxShadow: 0,
        }}
      >
        <Table sx={{}} size="small" aria-label="income reconciliation table">
          {/* <TableBody>
            <TableRow>
              <TableCell
                colSpan={6}
                sx={{
                  ...styledAccordion.accordionBorderCell,
                  padding: '0 0 0 20px',
                  borderBottom: '0px',
                  // borderTop: '1px solid #ddd',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    padding: '0',
                    '&>div': {
                      padding: '12px 16px',
                      borderLeft: '1px solid #ddd',
                      fontWeight: '600',
                      textAlign: 'center',
                    },
                    '&>div:first-of-type': {
                      borderTopColor: '#fff',
                      borderLeft: 'none',
                      fontWeight: '400',
                      textAlign: 'left',
                      paddingLeft: '0px',
                    },
                    '&>div.differenceCell+div': {
                      backgroundColor: gaugeColors.highlight,
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      ...styledAccordion.accordionSummaryTableHeader,
                    }}
                  >
                    Working Take Home Pay:
                  </Typography>
                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableCell}
                  >
                    {dollarFormat.format(adjustedWorkingNetTakeHome)}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      padding: '0 !important',
                      borderLeft: '0 !important',
                      borderRadius: '0 !important',
                      width: '20px',
                    }}
                  ></Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody> */}
          <TableBody>
            <TableRow>
              <TableCell colSpan={6} sx={styledAccordion.accordionBorderCell}>
                <Accordion
                  expanded={expanded === 'panel6'}
                  onChange={handleChange('panel6')}
                  sx={styledAccordion.accordionWrapper}
                >
                  <AccordionSummary
                    aria-controls="panel6-content"
                    id="panel6-header"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Box sx={styledAccordion.accordionSummaryTable}>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={styledAccordion.accordionSummaryTableHeader}
                      >
                        Working Take Home Pay:
                      </Typography>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          ...styledAccordion.accordionSummaryTableCell,
                          fontWeight: '600',
                          borderLeft: 'none !important',
                        }}
                      >
                        {dollarFormat.format(adjustedWorkingNetTakeHome)}
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails onClick={handleChange('close')}>
                    <TableContainer
                      component={Paper}
                      sx={styledAccordion.accordionDetailsTableContainer}
                    >
                      <Table
                        sx={{ display: 'block' }}
                        size="small"
                        aria-label="income reconciliation table"
                      >
                        <TableBody sx={{ display: 'block' }}>
                          <TableRow
                            sx={
                              styledAccordion.accordionDetailsTableContainerRow
                            }
                          >
                            <TableCell>Working Pay</TableCell>
                            <TableCell align="center">
                              +{dollarFormat.format(workingNetTakeHome)}
                            </TableCell>
                          </TableRow>
                          <TableRow
                            sx={
                              styledAccordion.accordionDetailsTableContainerRow
                            }
                          >
                            <TableCell>Cash Addbacks</TableCell>
                            <TableCell align="center">
                              +{dollarFormat.format(cashAddbacksTotals.working)}
                            </TableCell>
                          </TableRow>
                          {intakeState?.alreadyCollectingSocialSecurity && (
                            <TableRow
                              sx={
                                styledAccordion.accordionDetailsTableContainerRow
                              }
                            >
                              <TableCell>Social Security</TableCell>
                              <TableCell align="center">
                                +
                                {dollarFormat.format(
                                  intakeState?.estimatedSocialSecurity || 0
                                )}
                              </TableCell>
                            </TableRow>
                          )}
                          {workingIncomesExpenses.map(
                            (incomeExpenseItem, index) => (
                              <TableRow
                                key={index}
                                sx={
                                  styledAccordion.accordionDetailsTableContainerRow
                                }
                              >
                                <TableCell>
                                  {incomeExpenseItem.name || 'Unlabeled Item'}
                                </TableCell>
                                <TableCell align="center">
                                  {incomeExpenseItem.retirement > 0 ? '+' : ''}
                                  {dollarFormat.format(
                                    incomeExpenseItem.retirement || 0
                                  )}
                                </TableCell>
                              </TableRow>
                            )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              </TableCell>
            </TableRow>
          </TableBody>
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={6}
                sx={{
                  ...styledAccordion.accordionBorderCell,
                  padding: '0 0 0 20px',
                  borderBottom: '0px',
                  borderTop: '1px solid #ddd',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    padding: '0',
                    '&>div': {
                      padding: '12px 16px',
                      borderLeft: '1px solid #ddd',
                      textAlign: 'center',
                      fontWeight: '600',
                    },
                    '&>div:first-of-type': {
                      borderTopColor: '#fff',
                      borderLeft: 'none',
                      fontWeight: '400',
                      textAlign: 'left',
                      paddingLeft: '0px',
                    },
                    '&>div.differenceCell+div': {
                      backgroundColor: gaugeColors.highlight,
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableHeader}
                  >
                    Retired Take Home Pay:
                  </Typography>
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      ...styledAccordion.accordionSummaryTableCell,
                      borderLeft: 'none !important',
                    }}
                  >
                    {dollarFormat.format(adjustedNetTakeHomeInRetirement)}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      padding: '0 !important',
                      borderLeft: '0 !important',
                      borderRadius: '0 !important',
                      width: '20px',
                    }}
                  ></Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={6}
                sx={{
                  ...styledAccordion.accordionBorderCell,
                  padding: '0 0 0 20px',
                  borderBottom: '0px',
                  borderTop: '4px solid #ddd',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    padding: '0',
                    '&>div': {
                      padding: '12px 16px',
                      textAlign: 'center',
                      fontWeight: '600',
                      // borderTop: '4px solid #ddd',
                    },
                    '&>div:first-of-type': {
                      // borderTopColor: '#fff',
                      fontWeight: '400',
                      textAlign: 'left',
                      paddingLeft: '0px',
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={styledAccordion.accordionSummaryTableHeader}
                  >
                    <b>Gap</b> (Working - Retired)
                  </Typography>
                  <Typography
                    variant="body2"
                    component="div"
                    className="differenceCell"
                    sx={{
                      ...styledAccordion.accordionSummaryTableCell,
                      // border: `1px solid ${gaugeColors.full} !important`,
                      color: bannerColors.full,
                    }}
                  >
                    {dollarFormat.format(
                      Math.abs(adjustedNetTakeHomeDifference)
                    )}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      padding: '0 !important',
                      borderLeft: '0 !important',
                      borderRadius: '0 !important',
                      width: '20px',
                    }}
                  ></Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
